import script from "./TipsPop.vue?vue&type=script&lang=ts&setup=true"
export * from "./TipsPop.vue?vue&type=script&lang=ts&setup=true"

import "./TipsPop.vue?vue&type=style&index=0&id=bd8def8c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd8def8c"]])

export default __exports__